import { useTheme } from '@mui/material';
import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { ClosedGateIcon, OpenGateIcon } from 'assets';
import { getIconColor } from 'components/alerts/alerts.logic';
import { OpenStatus } from 'shared';

export const getGateItemIcons = ({ openStatus }: ILockerGateItem) => {
	const theme = useTheme();
	const iconColor = getIconColor(openStatus, theme);

	const icons = [
		{
			component: <ClosedGateIcon color={iconColor} />,
			show: openStatus === OpenStatus.Closed,
		},
		{
			component: <OpenGateIcon color={iconColor} />,
			show: openStatus !== OpenStatus.Closed,
		},
	];

	return icons.filter(({ show }) => show).map(({ component }) => component);
};
